import { SET_CALL_DETAIL, CLEAR_CALL_DETAIL } from "../actions/callDetailActions";

const initialState = {
  selectedId: null,
  selectedDate: null,
  selectedName:null
};

const callDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CALL_DETAIL:
      return {
        ...state,
        selectedId: action.payload.id,
        selectedDate: action.payload.date,
        selectedName:action.payload.name
      };

    case CLEAR_CALL_DETAIL:
      return initialState;

    default:
      return state;
  }
};

export default callDetailReducer;
